import api from '../../services/api';
import { useRef } from 'react';

interface requestPrint {
    id: string;
    orgaoNome: string;
    descricao: string;
    dataDemanda: string;
    prioridade: string;
    veiculoNome: string;
    placa: string;
    motoristaNome: string;
    dataAutorizacao: string;
    pessoaAutorizado: string;
    tipoCombustivel: string;
    qtdSolicitada: number;
    qtdAutorizada: number;
    intinerario: string;
}

const PrintDemand = () => {
    const toastPrint: any = useRef();

    const transformDataInBlob = (response: any, filename?: string) => {
        let blob = new Blob([response.data], {
            type: 'application/pdf',
        });

        if (response.data.byteLength < 100) {
            toastPrint.current.show({
                severity: 'warn',
                summary: 'Falha na Operação.',
                detail: 'Erro inesperado, tente novamente ou entre em contato',
                life: 5000,
            });

            return false;
        } else {
            toastPrint.current.show({
                severity: 'success',
                summary: 'Autorização gerada com sucesso.',
                detail: 'Verifique os seus downloads ou abas do navegador',
                life: 5000,
            });
        }

        const file = new File([blob], `${filename}-${new Date().toLocaleDateString()}.pdf`);

        let url = window.URL.createObjectURL(file);

        if (navigator.userAgent.match(/Chrome/i)) {
            url = window.URL.createObjectURL(blob);
        }

        let link = document.createElement('a');
        link.href = url;

        window.open(link.href);

        setTimeout(() => {
            window.URL.revokeObjectURL(url);
        }, 100);
    };

    const sendToPrint = async (data: any) => {
        const qtdSolicitada = Number(data.QUANTIDADECOMBUSTIVELSOLICITADO);

        // TODO: finalizar o fetch
        const dataPrint: requestPrint = {
            id: data.ID,
            intinerario: data.ITINERARIO,
            orgaoNome: data.NOME_ORGAO,
            descricao: data.DESCRICAO,
            dataDemanda: data.DATA,
            prioridade: data.PRIORIDADE,
            veiculoNome: data.NOME_VEICULO,
            placa: data.PLACA_VEICULO,
            motoristaNome: data.NOME_PESSOAORIGEM,
            dataAutorizacao: data.DATA,
            pessoaAutorizado: data.NOME_PESSOADESTINO,
            tipoCombustivel: data.FT_TIPOCOMBUSTIVEL,
            qtdSolicitada: qtdSolicitada,
            qtdAutorizada: 0,
        };
        console.log("dataPrint: ",dataPrint)
        try {
            await api
                .post(`printDemands`, dataPrint, {
                    responseType: 'arraybuffer',
                })
                .then(response => {
                    transformDataInBlob(response, 'PDF');
                });
        } catch (error) {
            console.log(error);
        } finally {
        }
    };

    return {
        printCall: {
            sendToPrint,
            toastPrint,
        },
    };
};

export default PrintDemand;
